import Application from '@ember/application';
function getAssetMapUrl() {
  const metaTag = document.querySelector("meta[name='ember-cli-ifa:assetMap']");
  if (!metaTag) {
    return null;
  }
  return metaTag.content ? JSON.parse(decodeURIComponent(metaTag.content)) : null;
}

// This app initializer reads a meta tag to get the URL of the asset map, fetches it, and stores it for later
// consumption by the asset-map _instance_ initializer. We do this in two steps because app initializers are able to
// pause app boot and do async tasks (like fetching files), but do not have access to the app instance and corresponding
// services.
export async function initialize(app) {
  // Don't run this if we're inside of an Engine.
  if (!(app instanceof Application)) {
    return;
  }
  const assetMapUrl = getAssetMapUrl();

  // If the asset map URL doesn't exist, the service is effectively disabled (e.g. in testing or development)
  if (!assetMapUrl) {
    return;
  }
  app.deferReadiness();
  try {
    // Fetch and process the asset map
    const response = await fetch(assetMapUrl);
    if (!response.ok) {
      throw new Error(`Failed to fetch the asset map json: '${response.status} ${response.statusText}'`);
    }
    const assetMapConfig = await response.json();

    // Store the asset map so it can later be read by the instance initializer and set on the asset-map service
    app.register('config:asset-map', assetMapConfig, {
      instantiate: false
    });
  } finally {
    app.advanceReadiness();
  }
}
export default {
  name: 'asset-map',
  initialize
};